import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints.ts';

import { GlobalFilterResponse, UpdateGlobalFilterParams } from '@/types/globalFilter';
import { FindOneUserResponse, GetPractitionersQuery, GetPractitionersResponse } from '@/types/user';

export const userApiSlice = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [API_SLICE.User],
  endpoints: (builder) => ({
    getCurrentUserInfo: builder.query<FindOneUserResponse, void>({
      query: () => ({
        url: API_ENDPOINTS.USERS.CURRENT_USER,
        method: 'GET'
      }),
      providesTags: () => [{ type: API_SLICE.User, id: 'CURRENT_USER' }]
    }),
    getGlobalFilter: builder.query<GlobalFilterResponse, void>({
      query: () => ({
        url: API_ENDPOINTS.USERS.GLOBAL_FILTER,
        method: 'GET'
      })
    }),

    updateGlobalFilter: builder.mutation<GlobalFilterResponse, UpdateGlobalFilterParams>({
      query: (body) => ({
        url: API_ENDPOINTS.USERS.GLOBAL_FILTER,
        method: 'PATCH',
        body
      }),
      invalidatesTags: (_result, _error, _args) => [{ type: API_SLICE.User, id: 'CURRENT_USER' }]
    }),
    getPractitionersByClinicId: builder.query<GetPractitionersResponse, GetPractitionersQuery>({
      query: ({ clinicIds }) => ({
        url: API_ENDPOINTS.USERS.PRACTITIONERS_BY_CLINIC_ID,
        method: 'POST',
        body: { clinicIds, fetchAll: true }
      })
    })
  })
});

export const {
  useGetCurrentUserInfoQuery,
  useGetGlobalFilterQuery,
  useUpdateGlobalFilterMutation,
  useGetPractitionersByClinicIdQuery
} = userApiSlice;
